module.exports = __webpack_public_path__ + "static/img/play_icon.30a08fef.png";